/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleResponseDto } from './RoleResponseDto';
import {
    RoleResponseDtoFromJSON,
    RoleResponseDtoFromJSONTyped,
    RoleResponseDtoToJSON,
    RoleResponseDtoToJSONTyped,
} from './RoleResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListRolesResponseDto
 */
export interface ListRolesResponseDto {
    /**
     * 
     * @type {Array<RoleResponseDto>}
     * @memberof ListRolesResponseDto
     */
    data: Array<RoleResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListRolesResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListRolesResponseDto interface.
 */
export function instanceOfListRolesResponseDto(value: object): value is ListRolesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListRolesResponseDtoFromJSON(json: any): ListRolesResponseDto {
    return ListRolesResponseDtoFromJSONTyped(json, false);
}

export function ListRolesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListRolesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(RoleResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListRolesResponseDtoToJSON(json: any): ListRolesResponseDto {
    return ListRolesResponseDtoToJSONTyped(json, false);
}

export function ListRolesResponseDtoToJSONTyped(value?: ListRolesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(RoleResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

